var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m3.509 16.803 20.273 8.496a4.68 4.68 0 0 0 5.07-.961L44.606 9.01M12.8 40.848l31.965-6.062a4.67 4.67 0 0 0 2.978-1.939 4.6 4.6 0 0 0 .73-3.456L44.178 6.745a4.6 4.6 0 0 0-1.945-2.949 4.67 4.67 0 0 0-3.48-.714L6.786 9.143a4.67 4.67 0 0 0-2.977 1.939 4.6 4.6 0 0 0-.73 3.456l4.294 22.646a4.6 4.6 0 0 0 1.944 2.95 4.67 4.67 0 0 0 3.48.713"
  })));
};
export default SvgMail;